import { MDSCalendarGrid } from "@/mds/components/date-time/calendars";
import { MDSButton, MDSButtonVariant } from "@/mds/components/buttons";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { StyledRangeCalendar, StyledHeader } from "./range-calendar.style";
import { IMDSRangeCalendarProps } from "./range-calendar.types";
import { MDSCalendarHeading } from "@/mds/components/date-time/calendars/calendar-heading";
import { MDSCalendarGridBody } from "@/mds/components/date-time/calendars/calendar-grid-body";
import { MDSCalendarGridHeader } from "@/mds/components/date-time/calendars/calendar-grid-header";
import { MDSCalendarHeaderCell } from "@/mds/components/date-time/calendars/calendar-header-cell";
import { MDSCalendarCell } from "@/mds/components/date-time/calendars/calendar-cell";

export function MDSRangeCalendar(props: IMDSRangeCalendarProps) {
  return (
    <StyledRangeCalendar {...props}>
      <StyledHeader>
        <MDSButton slot="previous" variant={MDSButtonVariant.Transparent}>
          <MDSIcon kind={MDSIconKind.AngleLeft} />
        </MDSButton>
        <MDSCalendarHeading />
        <MDSButton slot="next" variant={MDSButtonVariant.Transparent}>
          <MDSIcon kind={MDSIconKind.AngleRight} />
        </MDSButton>
      </StyledHeader>

      <MDSCalendarGrid>
        <MDSCalendarGridHeader>
          {day => <MDSCalendarHeaderCell>{day}</MDSCalendarHeaderCell>}
        </MDSCalendarGridHeader>
        <MDSCalendarGridBody>{date => <MDSCalendarCell date={date} />}</MDSCalendarGridBody>
      </MDSCalendarGrid>
    </StyledRangeCalendar>
  );
}
